import UpdateIcon from '@mui/icons-material/Update';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button, Chip, CircularProgress, Paper, Table, TableBody, TableCell, tableCellClasses, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Typography } from '@mui/material';
import { getObjectByIdApi, getObjectListByPropertyApi } from 'api/general';
import DecisionStatusUpdateDialog from 'app/components/Dialog/DecisionStatusUpdateDialog';
import PreviewMeetingDialog from 'app/components/Dialog/PreviewMeetingDialog';
import ReportMenuGroup from 'app/components/ReportMenuGroup';
import ReviewRecords from 'app/components/Table/ReviewRecords';
import { getLocaleDateWithTimeCustomV2, getSubjectName, getUserFullName, sortByProperty, stripHTMLTags } from 'app/utils/appHelpers';
import { MEETING_USER, MEETINGS } from 'app/utils/constants/customConstant';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DecisionStatusListDataTableFilter from './DecisionStatusListDataTableFilter';
import DecisionStatusListDataTableToolbar from './DecisionStatusListDataTableToolbar';
import { getDstatusSearchListByMeetingIdPDFApi } from 'api/pdf';
import { styled } from '@mui/material/styles';
import { CustomTooltipBlack } from 'app/components/Tooltip/CustomTooltip';
import CommentIcon from '@mui/icons-material/Comment';
import { setCurrentMeetingUsers } from 'stores/meeting';
import LoadingPopUp from 'app/components/LoadingPopup';


function DecisionStatusListDataTable({ mainData, column, type }) {


    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));


    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState(mainData);
    const [data2, setData2] = useState(mainData);
    const [previewMeetingDialogStatus, setPreviewMeetingDialogStatus] = useState(false);
    const [selectedPreviewMeeting, setSelectedPreviewMeeting] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const subjectList = useSelector(state => state.subject.data || []);
    const [dstatusDialogStatus, setDstatusDialogStatus] = useState(false);
    const [selectedDecision, setSelectedDecision] = useState({});

    const handlePreviewButtonClick = async (meetingId) => {
        const res = await getObjectByIdApi(MEETINGS, meetingId)
        setSelectedPreviewMeeting(res.data);
        setPreviewMeetingDialogStatus(true)
    }
    const handleRequestSort = (event, property) => {
        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }

        const tempdata =
            tempOrder === 'desc'
                ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
                : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

        setData(tempdata);
        setOrder(tempOrder);
        setOrderBy(tempOrderBy);

    };
    const tableCellStyle = { fontSize: '12px' };
    const commonColumnStyle = { ...tableCellStyle, minWidth: 30, maxWidth: 50 };
    const DataTableHead = ({ onRequestSort, customColumnData }) => {
        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow >
                    {customColumnData.map(column => (
                        <TableCell
                            key={column.id}
                            align={column.align}
                            padding={column.disablePadding ? 'none' : 'normal'}
                            sx={column.sx}  // sx özelliklerini uyguluyoruz
                        >
                            <Tooltip
                                title="Sırala"
                                placement={column.align === 'right' ? 'bottom-end' : 'bottom-start'}
                                enterDelay={300}
                            >
                                <TableSortLabel
                                    active={orderBy === column.id}
                                    direction={order}
                                    onClick={createSortHandler(column.id)}
                                >
                                    {column.label}
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    };

    const userList = useSelector(state => state.user.data || []);
    const dispatch = useDispatch();
    const handleDStatusButonClick = (item) => {

        const fetchMeetingUsers = async () => {
            let resultMeetingMembers = await getObjectListByPropertyApi(MEETING_USER, "meetingId", item.meetingId);
            let data = resultMeetingMembers.data;
            data = sortByProperty(data, "indexNo");
            data = data.filter(x => x.type === 1)
            let mUsers = [];
            data.forEach(element => {
                const user = userList.find(item => item.id === element.userId);
                mUsers.push(user)
            });

            dispatch(setCurrentMeetingUsers(mUsers))
            setSelectedDecision(item);
            setDstatusDialogStatus(true);
        }
        fetchMeetingUsers()
    };

    const afterUpdateFunc = (updatedFields, recordId) => {
        const updatedData = data.map(item =>
            item.id === recordId ? { ...item, ...updatedFields } : item
        );
        setData([...updatedData]);
        setData2([...updatedData]);

        setSelectedDecision(prev => (prev && prev.id === recordId) ? { ...prev, ...updatedFields } : prev);
    };

    const [searchType, setSearchType] = useState("toolbar");

    const handleReportClick = async () => {
        setLoading(true);
        let payload = {};
        if (searchType === "toolbar") {

            payload = {
                filters: toolbarSearchPayload,
                searchType: searchType

            }
        } else {

            payload = {
                filters: selectedFilters,
                searchType: searchType

            };

        }

        await getDstatusSearchListByMeetingIdPDFApi(payload);


        setLoading(false);
    };


    const [toolbarSearchPayload, setToolbarPayload] = useState({});
    return (
        <Paper className="col-md-12">

            <DecisionStatusListDataTableToolbar
                pageTitle={type === "yk" ? "Tüm YK Toplantıları" : "Tüm Kurul/Komisyon Toplantıları"}
                type={type}
                setSearchType={setSearchType}
                data2={data2}
                setData={setData}
                setLoading={setLoading}
                setToolbarPayload={setToolbarPayload}
            />

            <DecisionStatusListDataTableFilter
                data={data2}
                setFilterData={(data) => setData(data)}
                setPage={setPage}
                setSelectedFilters={setSelectedFilters}
                loading={loading}
                setLoading={setLoading}
                type={type}
                setSearchType={setSearchType}
            />

            <LoadingPopUp open={loading} />
            {!loading && (

                <>

                    {data && data.length > 0 && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, mr: 1 }}>
                            <Tooltip title="PDF/WORD Raporunu oluştur">
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => handleReportClick(data)}
                                >
                                    Rapor Oluştur
                                </Button>
                            </Tooltip>
                        </Box>
                    )}


                    {Object.keys(selectedFilters).length > 0 && (
                        <div style={{ margin: '10px', display: 'flex', flexWrap: 'wrap' }}>
                            {Object.entries(selectedFilters).map(([key, value]) => {
                                if (
                                    value === null ||
                                    (Array.isArray(value) && value.length === 0) ||
                                    value === ""
                                )
                                    return null;
                                if (key === "pageType") {
                                    return null;
                                }
                                if (key === "statFinish") {
                                    return value === 1 ? (
                                        <Chip
                                            key={key}
                                            label="Tamamlanan Toplantılar"
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                if (key === "applied") {
                                    return value ? (
                                        <Chip
                                            key={key}
                                            label="Uygulananlar"
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                if (key === "notApplied") {
                                    return value ? (
                                        <Chip
                                            key={key}
                                            label="Uygulanmayanlar"
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                if (["principle", "supp", "secret"].includes(key)) {
                                    const mapping = {
                                        principle: "İlke Kararı",
                                        supp: "Ek Gündem",
                                        secret: "Gizli"
                                    };
                                    return value === 1 ? (
                                        <Chip
                                            key={key}
                                            label={mapping[key]}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    ) : null;
                                }
                                const combinedFields = [
                                    "meetingInst",
                                    "decisionDepartments",
                                    "decisionSubjectIds",
                                    "meetingUnitIds",
                                    "meetingAdminUserIds",
                                    "meetingCreatorUserIds",
                                    "meetingParticipantUserIds",
                                    "statusReviewUserIds"
                                ];
                                if (Array.isArray(value) && combinedFields.includes(key)) {
                                    let chipLabel = "";
                                    if (key === "meetingInst") {
                                        chipLabel = "Kurum: " + value.join(", ");
                                    } else if (key === "decisionDepartments") {
                                        chipLabel = "İlgili Kurum/Birim: " + value.join(", ");
                                    } else if (key === "decisionSubjectIds") {
                                        const labels = value.map(item => item.name || item);
                                        chipLabel = "Konu: " + labels.join(", ");
                                    } else if (key === "meetingUnitIds") {
                                        const labels = value.map(item => item.name);
                                        chipLabel = "Kurul/Kol/Komisyon: " + labels.join(", ");
                                    } else if (["meetingAdminUserIds", "meetingCreatorUserIds", "meetingParticipantUserIds", "statusReviewUserIds"].includes(key)) {
                                        const userKeyMapping = {
                                            meetingAdminUserIds: "Toplantı Yöneticisi",
                                            meetingCreatorUserIds: "Üyeler",
                                            meetingParticipantUserIds: "Katılımcılar",
                                            statusReviewUserIds: "Uygulama Durumu Güncelleyenler"
                                        };
                                        const labels = value.map(item => getUserFullName(item) || item);
                                        chipLabel = `${userKeyMapping[key]}: ${labels.join(", ")}`;
                                    } else {
                                        chipLabel = `${key}: ${value.join(", ")}`;
                                    }
                                    return (
                                        <Chip
                                            key={key}
                                            label={chipLabel}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    );
                                }
                                if (typeof value === "string") {
                                    const stringLabelMapping = {
                                        agendaText: "Gündem/Karar",
                                        // decisionText: "Karar",
                                        meetingNo: "Toplantı Sayı"
                                    };
                                    const labelPrefix = stringLabelMapping[key] || key;
                                    return (
                                        <Chip
                                            key={key}
                                            label={`${labelPrefix}: ${value}`}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    );
                                }
                                if (value && value.format) {
                                    const dateLabelMapping = {
                                        pdateStart: "Başlangıç Tarihi",
                                        pdateEnd: "Bitiş Tarihi"
                                    };
                                    const labelPrefix = dateLabelMapping[key] || key;
                                    return (
                                        <Chip
                                            key={key}
                                            label={`${labelPrefix}: ${value.format("DD/MM/YYYY")}`}
                                            size="small"
                                            style={{ marginRight: 4, marginBottom: 4 }}
                                        />
                                    );
                                }
                                return null;
                            })}
                        </div>
                    )}

                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table size="small" aria-label="customized table">

                                <DataTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={data.length}
                                    customColumnData={column}
                                />

                                <TableBody>
                                    {data
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((n) => {


                                            return (
                                                <StyledTableRow hover key={"trO" + n.id}>
                                                    {/* 
                                                    <TableCell align="center" padding="normal" sx={commonColumnStyle}>
                                                        {n.decisionNo}
                                                    </TableCell> */}

                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, minWidth: 80, maxWidth: 100 }}>

                                                        <Typography align="left" style={{ display: 'block', ...tableCellStyle }}>
                                                            ({n.id})
                                                        </Typography>
                                                        <Typography variant="caption" style={{ display: 'block', ...tableCellStyle }}>
                                                            {n.inst} {n.unit} {n.meetingNo} /   {n.decisionNo}
                                                            <Typography>
                                                                {n.meetingDate ? getLocaleDateWithTimeCustomV2('tr', n.meetingDate) : ""}
                                                            </Typography>

                                                        </Typography>

                                                    </StyledTableCell>



                                                    <StyledTableCell align="center" padding="normal" sx={commonColumnStyle}>
                                                        {n.department}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, maxWidth: 70 }}>
                                                        {getSubjectName(n.subjectId, subjectList)}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, minWidth: 200, maxWidth: 350, whiteSpace: 'pre-line' }}>
                                                        {stripHTMLTags(n.agenda)}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left" padding="normal" sx={{ ...tableCellStyle, minWidth: 200, maxWidth: 350, whiteSpace: 'pre-line' }}>
                                                        {stripHTMLTags(n.decision)}
                                                    </StyledTableCell>




                                                    <StyledTableCell align="center" padding="none" sx={{ ...tableCellStyle, minWidth: 100, maxWidth: 100 }}>
                                                        {n.status === 1 ? (
                                                            <Chip
                                                                label="Uygulandı"
                                                                size="small"
                                                                color="success"
                                                                sx={{
                                                                    mb: 1,
                                                                    mt: 1,
                                                                    height: '20px',
                                                                    '& .MuiChip-label': {
                                                                        fontSize: '10px',
                                                                        paddingLeft: '4px',
                                                                        paddingRight: '4px',
                                                                    },
                                                                }}
                                                            />
                                                        ) : n.status === 0 ? (
                                                            <Chip
                                                                label="Uygulanmadı"
                                                                size="small"
                                                                color="error"
                                                                sx={{
                                                                    mb: 1,
                                                                    mt: 1,
                                                                    height: '20px',
                                                                    '& .MuiChip-label': {
                                                                        fontSize: '10px',
                                                                        paddingLeft: '4px',
                                                                        paddingRight: '4px',
                                                                    },
                                                                }}
                                                            />
                                                        ) : (
                                                            n.status
                                                        )}

                                                        {n.userStatusId && (

                                                            <ReviewRecords n={n} viewType="datatable" />

                                                        )}
                                                    </StyledTableCell>

                                                    <StyledTableCell align="center" padding="none" sx={{ ...tableCellStyle, minWidth: 80, maxWidth: 100 }}>

                                                        <CustomTooltipBlack
                                                            placement="top-start"
                                                            arrow
                                                            title={
                                                                <div>
                                                                    <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                        İlke Kararı : {n.principle}
                                                                    </Typography>
                                                                    <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                        Ek Gündem : {n.supp}
                                                                    </Typography>
                                                                    <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                        Gizli : {n.secret}
                                                                    </Typography>
                                                                    <Typography variant="caption" style={{ display: 'block', fontSize: '10px' }}>
                                                                        Tamamlanmış Mı? : {n.statFinish === 1 ? 'Evet' : 'Hayır'}
                                                                    </Typography>
                                                                </div>
                                                            }
                                                        >
                                                            <CommentIcon fontSize="small" />
                                                        </CustomTooltipBlack>

                                                        <Tooltip title="Raporlar">
                                                            <ReportMenuGroup meeting={n} decisionId={n.id} type="agenda" fromPage={"detail"} />
                                                        </Tooltip>
                                                        <Tooltip title="Toplantı Bilgi Önizleme">
                                                            <Button
                                                                color="primary"
                                                                sx={{ minWidth: 20, p: '5px' }}
                                                                onClick={async () => {
                                                                    await handlePreviewButtonClick(n.meetingId);
                                                                }}
                                                            >
                                                                <VisibilityIcon fontSize="small" />
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip title="Uygulanma Durumu Güncelle">
                                                            <Button
                                                                color="secondary"
                                                                sx={{ minWidth: 20, p: '5px' }}
                                                                onClick={() => handleDStatusButonClick(n)}
                                                            >
                                                                <UpdateIcon fontSize="small" />
                                                            </Button>
                                                        </Tooltip>
                                                    </StyledTableCell>




                                                </StyledTableRow>
                                            );
                                        })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={(e, page) => setPage(page)}
                                            onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                                            labelRowsPerPage={"Görüntülenecek Satır"}
                                            rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                            showFirstButton
                                            showLastButton
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                    <PreviewMeetingDialog
                        meeting={selectedPreviewMeeting}
                        onClose={() => setPreviewMeetingDialogStatus(false)}
                        open={previewMeetingDialogStatus}
                    />
                    <DecisionStatusUpdateDialog
                        selectedDecision={selectedDecision}
                        open={dstatusDialogStatus}
                        onClose={() => setDstatusDialogStatus(false)}
                        afterUpdateFunc={afterUpdateFunc}
                    />


                </>
            )
            }
        </Paper >
    );
};

export default DecisionStatusListDataTable;